/**
 * Marketplace (Faza 1) — publish + moderatsiya kontrakt sxemalari.
 *
 * Oqim:
 *   1. Sotuvchi (EGASI/ADMIN): publishRequest → Product.marketplaceStatus PENDING.
 *   2. Platforma admin: moderationDecision → APPROVE (CatalogItem/Offer jonli) yoki
 *      REJECT (sabab bilan).
 *   3. Admin: mergeReviewResolve → dedup ziddiyatini MERGED/SPLIT qiladi.
 *
 * Pul DTO'larda STRING (Decimal → string; "Float yo'q" qoidasi).
 */
import { z } from 'zod';
/** Decimal(15,2) — eng katta qiymat (schema cheklovi). */
const MAX_MONEY = 9_999_999_999_999.99;
// ─── Sotuvchi: marketplace'ga chiqarish so'rovi ───────────────────
// productId — route param (RESTful), shu sababli body'da emas.
export const publishRequestSchema = z.object({
    marketplacePrice: z
        .number()
        .positive('Narx 0 dan katta boʻlishi kerak')
        .max(MAX_MONEY, 'Narx juda katta'),
    condition: z.enum(['NEW', 'USED']).optional(),
});
// ─── Sotuvchi: BIR-BOSQICHLI publish (EGASI = platforma egasi) ────
// marketplacePrice ixtiyoriy — berilmasa product.price ishlatiladi.
// Moderatsiyasiz darhol APPROVED + katalog sync (single-owner biznes uchun).
export const publishNowSchema = z.object({
    marketplacePrice: z
        .number()
        .positive('Narx 0 dan katta boʻlishi kerak')
        .max(MAX_MONEY, 'Narx juda katta')
        .optional(),
    condition: z.enum(['NEW', 'USED']).optional(),
});
// ─── Sotuvchi: KO'P mahsulotni birdan publish (bulk) ──────────────
// Har mahsulot o'z narxida (product.price) chiqadi. UI'da tanlangan
// mahsulotlarni bir tugma bilan marketplace'ga chiqarish uchun.
export const bulkPublishSchema = z.object({
    ids: z
        .array(z.string().uuid())
        .min(1, 'Kamida bitta mahsulot tanlang')
        .max(500, 'Bir martada eng ko‘pi 500 ta'),
});
// ─── Platforma admin: moderatsiya qarori (approve/reject) ─────────
export const moderationDecisionSchema = z
    .object({
    action: z.enum(['APPROVE', 'REJECT']),
    reason: z.string().trim().max(500).optional(),
})
    .refine((d) => d.action !== 'REJECT' || (d.reason !== undefined && d.reason.length > 0), {
    message: 'Rad etish uchun sabab kiritilishi shart',
    path: ['reason'],
});
// ─── Admin: dedup merge review'ni hal qilish ──────────────────────
export const mergeReviewResolveSchema = z.object({
    resolution: z.enum(['MERGED', 'SPLIT']),
});
// ─── Moderatsiya navbati — query (pagination + filtr) ─────────────
export const moderationQueueQuerySchema = z.object({
    status: z.enum(['PENDING', 'APPROVED', 'REJECTED']).optional(),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(20),
});
//# sourceMappingURL=marketplace.schema.js.map